import React from "react";

function warningOrange({fill}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 8C17.85 8 8 17.85 8 30C8 42.15 17.85 52 30 52C42.15 52 52 42.15 52 30C52 17.85 42.15 8 30 8ZM30 6C16.74 6 6 16.75 6 30C6 43.25 16.74 54 30 54C43.26 54 54 43.25 54 30C54 16.75 43.26 6 30 6ZM30 34.25C29.31 34.25 28.75 33.69 28.75 33L28.75 19C28.75 18.31 29.31 17.75 30 17.75C30.69 17.75 31.25 18.31 31.25 19L31.25 33C31.25 33.69 30.69 34.25 30 34.25ZM28.75 40C28.75 40.69 29.31 41.25 30 41.25C30.69 41.25 31.25 40.69 31.25 40L31.25 39.8899C31.25 39.1999 30.69 38.6399 30 38.6399C29.31 38.6399 28.75 39.1999 28.75 39.8899L28.75 40Z"
        fill={ fill || "#FFC400"}
      />
    </svg>
  );
}

export default warningOrange;
